export interface DeleteTankProfileResultDto {
  status: DeleteTankProfileResultEnum;
  message: string;
  linkedReports: DeleteTankProfileResultLinkedReportDto[];
  tankProfileId: number;
}

export interface DeleteTankProfileResultLinkedReportDto {
  reportName: string;
  organizationName: string;
}

export enum DeleteTankProfileResultEnum {
  Success = 0,
  LinkedReportsFailure = 1,
  OtherFailure = 999
}
